import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Header cart control — matches fab-header-action style.
 */
const CartIcon = ({ cartCount = 0, onClick, label }) => {
  const content = (
    <>
      <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
      {cartCount > 0 ? (
        <span className="fab-header-action__badge" aria-label={`${cartCount} items in cart`}>
          {cartCount > 99 ? '99+' : cartCount}
        </span>
      ) : null}
      {label ? <span className="fab-header-action__label">{label}</span> : null}
    </>
  )

  if (typeof onClick === 'function') {
    return (
      <button
        type="button"
        className="fab-header-action"
        onClick={onClick}
        title="View cart"
        aria-label={cartCount > 0 ? `Cart, ${cartCount} items` : 'Cart'}
      >
        {content}
      </button>
    )
  }

  return (
    <Link
      to="/cart"
      className="fab-header-action"
      title="View cart"
      aria-label={cartCount > 0 ? `Cart, ${cartCount} items` : 'Cart'}
    >
      {content}
    </Link>
  )
}

export default CartIcon
